import { useState, useContext, useEffect } from "react";
import AuthContext from "../contexts/AuthContext";
import i18next from "i18next";
import { useTranslation } from "react-i18next";
import { Navbar, Nav, Dropdown } from "react-bootstrap";
import { useNavigate, NavLink } from "react-router-dom";
import { GoSignIn, GoSignOut } from "react-icons/go";
import { IoPersonAddSharp, IoPersonCircleSharp, IoMenuSharp} from "react-icons/io5";
import { FcGlobe } from "react-icons/fc";
import "flag-icon-css/css/flag-icons.min.css";

// import supported languages
import { languages, currentLanguageCode } from "../utilities/I18nLangConfig";

function MainLayout({ children, pageCSS }) {
  // Function to verify if user is scrolling
  // and changes the nav bar color to white
  const [colorChange, setColorchange] = useState(false);

  useEffect(() => {
    const handleScroll = () => setColorchange(window.scrollY >= 100);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // ?Language translations
  const { t } = useTranslation();

  const history = useNavigate();
  const auth = useContext(AuthContext);

  // Authentication routing functions
  const onRegsiter = () => {
    history("/register", { replace: true });
  };

  const onSignin = () => {
    history("/login", { replace: true });
  };

  const onSignOut = () => {
    auth.signOut();
    history("/login");
  };

  return (
    <>
      <Navbar
        expand="lg"
        fixed="top"
        className={colorChange ? "scroll" : "unscroll"}
      >
        <Navbar.Brand href="/">
          <img
            src={
              "https://res.cloudinary.com/dnfpmrdjl/image/upload/v1657646867/small%20icons/new-logo-1_i4ozds.png"
            }
            className="logo"
            alt="Ako Assurance Sarl logo"
          />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="navbarScroll">MENU <IoMenuSharp size={30}/></Navbar.Toggle>
        <Navbar.Collapse id="navbarScroll">
          <Nav className="me-auto flex-grow-1 justify-content-end" navbarScroll>
            <span className="nav-link">
              <NavLink to="/">{t("nav_home_link")}</NavLink>
            </span>

            <span className="nav-link">
              <NavLink to="/insurrances">{t("nav_insurrance_link")}</NavLink>
            </span>

            <span className="nav-link">
              <NavLink to="/about">{t("nav_about_link")}</NavLink>
            </span>

            <span className="nav-link">
              <NavLink to="/online-services">
                {t("nav_online_services_link")}
              </NavLink>
            </span>

            <span className="nav-link">
              <NavLink to="/blog">{t("nav_article_link")}</NavLink>
            </span>

            <span className="nav-link">
              <NavLink to="/contact">Contact</NavLink>
            </span>
          </Nav>
          <Dropdown className="auth-link">
            <Dropdown.Toggle variant="none" id="dropdown-basic-auth">
              <IoPersonCircleSharp className="auth-link-icon" />{" "}
              {t("nav_my_space_link")}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {auth.token ? (
                <span className="auth-link">
                  <Dropdown.Item onClick={onSignOut}>
                    <GoSignOut />
                    {t("nav_logout_link")}
                  </Dropdown.Item>
                </span>
              ) : (
                [
                  <span key={1} className="auth-link">
                    <Dropdown.Item onClick={onSignin}>
                      <GoSignIn />
                      {t("nav_login_link")}
                    </Dropdown.Item>
                  </span>,
                  <span key={2} className="auth-link">
                    <Dropdown.Item onClick={onRegsiter}>
                      <IoPersonAddSharp />
                      {t("nav_register_link")}
                    </Dropdown.Item>
                  </span>,
                ]
              )}
            </Dropdown.Menu>
          </Dropdown>
          <Dropdown className="lang-link">
            <Dropdown.Toggle variant="none" id="dropdown-basic-lang">
              <FcGlobe className="lang-link-icon" /> {t("nav_language_link")}
            </Dropdown.Toggle>

            <Dropdown.Menu>
              {languages.map(({ code, name, country_code }) => (
                <Dropdown.Item
                  className="lang-link-text"
                  key={country_code}
                  onClick={() => i18next.changeLanguage(code)}
                  // disabled={code === currentLanguageCode}
                >
                  <span
                    className={`flag-icon flag-icon-${country_code}`}
                    style={{ opacity: code === currentLanguageCode ? 0.5 : 1 }}
                  ></span>
                  &nbsp;{name}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </Navbar.Collapse>
        {/* Authentication links */}
      </Navbar>

      <div className={pageCSS}>{children}</div>
    </>
  );
}

export default MainLayout;
